import { ShiftModalComponentMap } from 'modals/ShiftModal/ShiftModal.constants';
import {
  shiftModalRoutingService,
  useShiftModalUIContext,
} from 'modals/ShiftModal/ShiftModal.ui.context';
import { useShiftModalDataContext } from 'modals/ShiftModal/ShiftModalProvider.data.context';
import { SendToAgenciesFormProvider } from 'modals/ShiftModal/src/views/SendToAgenciesView/SendToAgencies.form.context';
import { SendToAgenciesPropsProvider } from 'modals/ShiftModal/src/views/SendToAgenciesView/SendToAgencies.props.context';
import { AuthRouteDataProvider } from 'providers/AuthRouteDataProvider/AuthRouteDataProvider.context';
import { FC } from 'react';

const SendToAgenciesViewComponent: FC = () => {
  const { shiftModalActiveModalView } = useShiftModalUIContext();
  const { data } = useShiftModalDataContext();

  if (!data?.order?.canSendToAgency) shiftModalRoutingService.goToView('DetailView');
  const Component = ShiftModalComponentMap[shiftModalActiveModalView];
  return <Component />;
};

export const SendToAgenciesViewRenderer: FC = () => {
  return (
    <AuthRouteDataProvider>
      <SendToAgenciesFormProvider>
        <SendToAgenciesPropsProvider>
          <SendToAgenciesViewComponent />
        </SendToAgenciesPropsProvider>
      </SendToAgenciesFormProvider>
    </AuthRouteDataProvider>
  );
};
